import { useQuery } from "@tanstack/react-query"
import { API } from "config"
import moment from "moment"

const useBonusReport = (period) => useQuery({ queryKey: [`bonus-report`], queryFn: async () => {
    const callback = await API.get(`/bonus/report`)
    return callback?.data
}, staleTime: 1000 * 60 * 1 })

export default useBonusReport